import styled from 'styled-components';

export const GalleryContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MainImageContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 500px;
  margin-bottom: 1rem;
`;

export const MainImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  border: 1px solid #ccc;
`;

export const MainImageDeleteButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(255, 0, 0, 0.8);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px;
  cursor: pointer;
  z-index: 1;
  display: flex;
  align-items: center;

  &:hover {
    background-color: red;
  }
`;

export const MainImageActiveButton = styled.button`
  position: absolute;
  top: 10px;
  right: 50px;
  background-color: rgba(0, 123, 255, 0.8);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px;
  cursor: pointer;
  z-index: 1;
  display: flex;
  align-items: center;

  &:hover {
    background-color: #007bff;
  }
`;

export const ThumbnailGrid = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

export const Thumbnail = styled.img`
  width: 60px;
  height: 60px;
  object-fit: cover;
  border: ${(props) => (props.isActive ? '2px solid #007bff' : '1px solid #ccc')};
  border-radius: 4px;
  cursor: pointer;
`;